export const REGEX = {
  LINK: /^[a-z0-9\-_+/:]+\.[a-z0-9. \-_+]+$/i,
  EMAIL: /^[a-z0-9.\-_+]+@[a-z0-9\-_+]+\.[a-z0-9. \-_+]+$/i
};
